<template>
  <div class="bg-white py-2 px-2">
    <!-- <pre>
      {{ email_content }}
    </pre> -->
    <div class="flex justify-end">
      <v-icon @click="close_dialog"> mdi-close</v-icon>
    </div>
    <div class="text-center my-2 font-bold">NOTIFICATION</div>
    <div class="px-4 mb-4">
      <div class="border-b-2 border-gray-400">
        <div class="flex">
          <div class="mr-2">Date:</div>
          <div>
            {{ momentFormat(email_content.reg_date) }}
          </div>
        </div>
        <div class="flex">
          <div class="mr-2">Subject:</div>
          <div>
            {{ email_content.subject }}
          </div>
        </div>
      </div>
      <div
        class="my-2 bg-gray-100 p-2 leading-3"
        v-html="email_content.content"
      ></div>
      <div>
        <div v-if="validAttachments.length > 0">
          <h3 class="border-b-2 border-gray-400">Attachments</h3>
          <div
            v-for="(attachment, index) in validAttachments"
            :key="index"
            class="my-2"
          >
            <iframe
              :src="attachment"
              style="width: 100%; height: 500px; border: none;"
              @load="handleIframeLoad($event, index)"
              @error="handleIframeError(index)"
            />
          </div>
        </div>
        <div v-else-if="signedAttachments.length > 0" class="text-red-500 my-2">
          Attachments could not be loaded
        </div>
        <div v-else class="text-gray-500 my-2">No attachments</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getAttachmentPublicUrl } from "@/utils/attachmentUrl";
// import supabase from "../../../../supabase";

export default {
  props: ["email_content"],
  data() {
    return {
      attachments: [],
      signedAttachments: [],
      validAttachments: [], // Only attachments that are valid
    };
  },
  methods: {
    /**
     * Asynchronously creates a signed URL for the given attachment path.
     */
    getAttachmentUrl(attachmentPath) {
      return getAttachmentPublicUrl(attachmentPath);
    },

    handleIframeLoad(event, index) {
      // Check if the iframe content is an error message
      try {
        const iframeDoc = event.target.contentDocument || event.target.contentWindow.document;
        const content = iframeDoc.body.textContent || '';
        
        if (content.includes('"statusCode":"404"') || content.includes('Object not found')) {
          // Remove this attachment from validAttachments
          this.validAttachments = this.validAttachments.filter((_, i) => i !== index);
        }
      } catch (e) {
        // If we can't access the iframe content due to CORS, assume it's valid
        console.log("Could not check iframe content:", e);
      }
    },

    handleIframeError(index) {
      // Remove this attachment from validAttachments
      this.validAttachments = this.validAttachments.filter((_, i) => i !== index);
    },

    close_dialog() {
      this.$emit("close_dialog");
    },

    momentFormat(f) {
      return moment(f).format("LLL");
    },

    /**
     * Loads all attachments and converts each to its signed URL.
     */
    async loadSignedAttachments() {
      if (this.email_content && this.email_content.attachments) {
        this.attachments = this.email_content.attachments.split(",").filter(a => a.trim() !== '');
        
        // Use Promise.all to fetch all signed URLs and update our data property
        const urls = await Promise.all(
          this.attachments.map((path) => this.getAttachmentUrl(path))
        );
        
        // Filter out null values
        this.signedAttachments = urls.filter(url => url !== null);
        
        // Initially, assume all attachments are valid
        this.validAttachments = [...this.signedAttachments];
      }
    },
  },
  watch: {
    email_content: {
      handler() {
        this.loadSignedAttachments();
      },
      immediate: true,
    },
  },
};
</script>
